/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PurchaseOrderEmittedItemsApiModel {
  /**
   * Item code
   */
  code?: string;
  /**
   * Item ID
   */
  id?: string;
  /**
   * Item type
   */
  type?: PurchaseOrderEmittedItemsApiModelTypeEnum;
}
export enum PurchaseOrderEmittedItemsApiModelTypeEnum {
  Coupon = 'coupon',
  PrepaidCard = 'prepaid-card'
}
